import { render, staticRenderFns } from "./SearchPagination.vue?vue&type=template&id=e72146d8&scoped=true&"
import script from "./SearchPagination.vue?vue&type=script&lang=js&"
export * from "./SearchPagination.vue?vue&type=script&lang=js&"
import style0 from "./SearchPagination.vue?vue&type=style&index=0&id=e72146d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72146d8",
  null
  
)

export default component.exports